import { render, staticRenderFns } from "./OrdersCreateNeopharm.vue?vue&type=template&id=5fb5ccce&scoped=true&"
import script from "./OrdersCreateNeopharm.vue?vue&type=script&lang=js&"
export * from "./OrdersCreateNeopharm.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCreateNeopharm.vue?vue&type=style&index=0&id=5fb5ccce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5ccce",
  null
  
)

export default component.exports